import { zeroPad } from "../../utils/utils"
import {
  PlanFavouriteContainer,
  FloorPlan,
  Dimensions,
  InfoHolder,
  TitleHolder,
  Level,
  ApartID,
  CompasImage,
  Price
} from "./PlanFavouriteCard.styles"
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch"

export default function PlanFavouriteCard({ data }) {
  var formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "GBP",
    minimumFractionDigits: 0

    // These options are needed to round to whole numbers if that's what you want.
    //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
  })

  return (
    <PlanFavouriteContainer>
      {/* {data.price} */}
      {data.price === "N/A" || <Price>{formatter.format(data.price.replace(",", ""))}</Price>}
      <FloorPlan>
        <TransformWrapper>
          <TransformComponent
            wrapperStyle={{ width: "100%", height: "100%" }}
            contentStyle={{ width: "100%", height: "100%" }}
          >
            <img
              src={`assets/apartmentfinder/images/floorplans/${data.blockID.charAt(0)}_${
                data.flatType
              }.png`}
              alt="test"
              style={{ width: "100%", height: "100%" }}
            />
          </TransformComponent>
        </TransformWrapper>
      </FloorPlan>
      <InfoHolder>
        <Dimensions
          image={`${process.env.PUBLIC_URL}/assets/apartmentfinder/images/dimensions/${data.plot_num_planning}.svg`}
        />
        <TitleHolder>
          <Level>{zeroPad(data.floor_no, 2)}</Level>
          <ApartID>{data.id}</ApartID>
          <CompasImage
            alt="compass"
            src={`${process.env.PUBLIC_URL}/assets/apartmentfinder/icons/compass.png`}
          />
        </TitleHolder>
      </InfoHolder>
    </PlanFavouriteContainer>
  )
}
